import Footer from "../landing-page/components/Footer";

export default function PrivacyPage() {
  return (
    <div className="bg-background text-foreground min-h-screen">
      <main className="isolate">
        <div className="mx-auto max-w-4xl px-6 py-16 lg:px-8 lg:py-24">
          <div className="mx-auto max-w-3xl">
            <h1 className="text-4xl font-bold tracking-tight text-foreground sm:text-5xl">
              Politique de confidentialité
            </h1>
            <p className="mt-4 text-sm text-muted-foreground">
              Dernière mise à jour : 10 mars 2026
            </p>

            <div className="mt-10 space-y-10 text-base leading-7 text-muted-foreground">

              {/* 1. Responsable du traitement */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">1. Responsable du traitement</h2>
                <p>
                  Le responsable du traitement des données à caractère personnel collectées via le service Edgely est :
                </p>
                <div className="mt-4 p-4 bg-muted rounded-lg space-y-1">
                  <p><strong className="text-foreground">Edgely</strong> (auto-entrepreneur)</p>
                  <p>173 rue de Courcelles, 75017 Paris, France</p>
                  <p>
                    Contact données personnelles :{" "}
                    <a href="mailto:contact@edgely.trade" className="text-primary hover:underline">
                      contact@edgely.trade
                    </a>
                  </p>
                </div>
              </section>

              {/* 2. Données collectées */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">2. Données collectées</h2>
                <p>Nous collectons les catégories de données suivantes :</p>

                <h3 className="text-base font-semibold text-foreground mt-6 mb-2">2.1 Données d'identification et de compte</h3>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Adresse e-mail (obligatoire pour créer un compte)</li>
                  <li>Nom d'utilisateur ou pseudo (facultatif)</li>
                  <li>Mot de passe (stocké sous forme hachée, jamais en clair)</li>
                </ul>

                <h3 className="text-base font-semibold text-foreground mt-6 mb-2">2.2 Données de trading saisies par l'utilisateur</h3>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Journaux de trades (symboles, dates, prix, volumes, résultats P&L, notes)</li>
                  <li>Comptes de trading (dénomination, type, solde initial, devise)</li>
                  <li>Tags, routines, objectifs et sessions de trading</li>
                  <li>Analyses fondamentales et notes (texte et images)</li>
                </ul>
                <p className="mt-2 text-sm italic">
                  Ces données appartiennent exclusivement à l'utilisateur. Elles sont traitées uniquement pour fournir le service.
                </p>

                <h3 className="text-base font-semibold text-foreground mt-6 mb-2">2.3 Données de paiement</h3>
                <p>
                  Nous ne stockons pas vos données bancaires ou de carte de crédit. Ces données sont collectées et traitées
                  directement par notre prestataire de paiement Stripe (voir section 6). Nous conservons uniquement
                  l'identifiant d'abonnement et le statut du plan.
                </p>

                <h3 className="text-base font-semibold text-foreground mt-6 mb-2">2.4 Données de navigation et d'utilisation</h3>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Pages visitées sur le site (via Plausible Analytics — voir section 6)</li>
                  <li>Type de navigateur et système d'exploitation</li>
                  <li>Pays de connexion (sans stockage d'adresse IP)</li>
                  <li>Type d'appareil</li>
                </ul>

                <h3 className="text-base font-semibold text-foreground mt-6 mb-2">2.5 Fichiers téléversés</h3>
                <p>
                  Les images et fichiers que vous téléversez (captures d'écran de graphiques, etc.) sont stockés de manière
                  sécurisée sur Amazon Web Services S3, dans un bucket privé situé dans la région Europe (Paris, eu-west-3).
                </p>
              </section>

              {/* 3. Finalités et bases légales */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">3. Finalités du traitement et bases légales</h2>
                <div className="overflow-x-auto">
                  <table className="w-full text-sm border-collapse">
                    <thead>
                      <tr className="border-b border-border">
                        <th className="text-left py-2 pr-4 font-semibold text-foreground">Finalité</th>
                        <th className="text-left py-2 pr-4 font-semibold text-foreground">Données concernées</th>
                        <th className="text-left py-2 font-semibold text-foreground">Base légale</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-border">
                      <tr>
                        <td className="py-3 pr-4">Création et gestion du compte</td>
                        <td className="py-3 pr-4">Email, mot de passe, pseudo</td>
                        <td className="py-3">Exécution du contrat (art. 6.1.b RGPD)</td>
                      </tr>
                      <tr>
                        <td className="py-3 pr-4">Fourniture du service de journal de trading</td>
                        <td className="py-3 pr-4">Données de trading, fichiers</td>
                        <td className="py-3">Exécution du contrat (art. 6.1.b RGPD)</td>
                      </tr>
                      <tr>
                        <td className="py-3 pr-4">Traitement des paiements et gestion des abonnements</td>
                        <td className="py-3 pr-4">Email, identifiant Stripe, plan</td>
                        <td className="py-3">Exécution du contrat (art. 6.1.b RGPD)</td>
                      </tr>
                      <tr>
                        <td className="py-3 pr-4">Envoi d'e-mails transactionnels (confirmation, reset mot de passe)</td>
                        <td className="py-3 pr-4">Email</td>
                        <td className="py-3">Exécution du contrat (art. 6.1.b RGPD)</td>
                      </tr>
                      <tr>
                        <td className="py-3 pr-4">Mesure d'audience et amélioration du service</td>
                        <td className="py-3 pr-4">Données agrégées de navigation (Plausible)</td>
                        <td className="py-3">Intérêt légitime (art. 6.1.f RGPD)</td>
                      </tr>
                      <tr>
                        <td className="py-3 pr-4">Respect des obligations légales (comptabilité, fiscalité)</td>
                        <td className="py-3 pr-4">Données de facturation</td>
                        <td className="py-3">Obligation légale (art. 6.1.c RGPD)</td>
                      </tr>
                      <tr>
                        <td className="py-3 pr-4">Prévention des fraudes et sécurité</td>
                        <td className="py-3 pr-4">Données de compte et de connexion</td>
                        <td className="py-3">Intérêt légitime (art. 6.1.f RGPD)</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>

              {/* 4. Durées de conservation */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">4. Durées de conservation</h2>
                <ul className="space-y-3">
                  <li>
                    <strong className="text-foreground">Données de compte actif</strong> : conservées pendant toute la durée de vie du compte, puis supprimées dans un délai de 30 jours après la résiliation ou la demande de suppression.
                  </li>
                  <li>
                    <strong className="text-foreground">Données de trading</strong> : conservées pendant toute la durée de vie du compte. Supprimées à la fermeture du compte.
                  </li>
                  <li>
                    <strong className="text-foreground">Données de facturation</strong> : conservées 10 ans conformément aux obligations comptables et fiscales françaises (art. L.123-22 Code de commerce).
                  </li>
                  <li>
                    <strong className="text-foreground">Fichiers téléversés</strong> : conservés pendant toute la durée de vie du compte. Supprimés à la fermeture du compte.
                  </li>
                  <li>
                    <strong className="text-foreground">Données de navigation agrégées (Plausible)</strong> : données non personnelles ; conservation selon les paramètres de Plausible (données agrégées sans identifiant).
                  </li>
                  <li>
                    <strong className="text-foreground">Compte inactif</strong> : en cas d'inactivité supérieure à 3 ans, nous vous notifierons par email avant toute suppression.
                  </li>
                </ul>
              </section>

              {/* 5. Destinataires et partage des données */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">5. Destinataires des données</h2>
                <p>
                  Nous ne vendons, ne louons et ne partageons jamais vos données personnelles à des fins commerciales.
                  Les données peuvent être transmises aux sous-traitants suivants dans le strict cadre de la fourniture du service :
                </p>
                <ul className="mt-4 space-y-3">
                  <li>
                    <strong className="text-foreground">Hébergement</strong> : Amazon Web Services (AWS) — serveurs en Europe (Paris, eu-west-3) pour le stockage des données et des fichiers.
                  </li>
                  <li>
                    <strong className="text-foreground">Paiements</strong> : Stripe Inc. — traitement des paiements par carte (voir section 6).
                  </li>
                  <li>
                    <strong className="text-foreground">E-mails transactionnels</strong> : Resend Inc. — envoi des emails de confirmation, de réinitialisation de mot de passe et de facturation.
                  </li>
                  <li>
                    <strong className="text-foreground">Analytics</strong> : Plausible Analytics — mesure d'audience anonymisée (voir section 6).
                  </li>
                </ul>
                <p className="mt-4">
                  Nous pouvons également divulguer vos données si la loi l'exige, sur réquisition judiciaire, ou pour protéger nos droits légaux.
                </p>
              </section>

              {/* 6. Sous-traitants et transferts hors UE */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">6. Sous-traitants et transferts hors UE</h2>

                <h3 className="text-base font-semibold text-foreground mt-4 mb-2">Stripe (traitement des paiements)</h3>
                <p>
                  Stripe, Inc. (185 Berry Street, Suite 550, San Francisco, CA 94107, États-Unis) est notre sous-traitant
                  pour le traitement des paiements. À ce titre, Stripe agit en qualité de responsable de traitement
                  indépendant pour ses propres obligations (lutte contre la fraude, conformité réglementaire) et de
                  sous-traitant pour les données que nous lui confions. Le transfert de données vers les États-Unis est
                  encadré par les Clauses Contractuelles Types (CCT) de la Commission européenne.
                  Politique de confidentialité Stripe : <a href="https://stripe.com/fr/privacy" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">stripe.com/fr/privacy</a>
                </p>

                <h3 className="text-base font-semibold text-foreground mt-6 mb-2">Plausible Analytics (mesure d'audience)</h3>
                <p>
                  Nous utilisons Plausible Analytics pour mesurer l'audience et améliorer notre service. Plausible est un
                  outil respectueux de la vie privée qui ne collecte aucune donnée personnelle identifiable, n'utilise pas
                  de cookies, ne stocke pas d'adresse IP et ne partage aucune donnée avec des tiers. Les données collectées
                  sont agrégées et anonymes (type de navigateur, pays, pages visitées). Conformément à la délibération de
                  la CNIL relative aux outils de mesure d'audience, aucun consentement préalable n'est requis pour cet usage.
                  Plausible est hébergé dans l'Union européenne.
                  Politique de confidentialité Plausible : <a href="https://plausible.io/privacy" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">plausible.io/privacy</a>
                </p>

                <h3 className="text-base font-semibold text-foreground mt-6 mb-2">Amazon Web Services (hébergement)</h3>
                <p>
                  Les données et fichiers sont hébergés sur des serveurs AWS situés en Europe (région eu-west-3, Paris).
                  AWS est certifié conforme au RGPD et dispose d'un accord de traitement des données (DPA) conforme
                  aux CCT européennes.
                </p>

                <h3 className="text-base font-semibold text-foreground mt-6 mb-2">Resend (e-mails transactionnels)</h3>
                <p>
                  Resend, Inc. est utilisé pour l'envoi des e-mails transactionnels. Seule votre adresse e-mail est
                  transmise à Resend dans le cadre de l'envoi des messages. Le transfert vers les États-Unis est encadré
                  par les CCT européennes.
                </p>
              </section>

              {/* 7. Droits des personnes */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">7. Vos droits</h2>
                <p>
                  Conformément au Règlement Général sur la Protection des Données (RGPD) et à la Loi Informatique et
                  Libertés, vous disposez des droits suivants :
                </p>
                <ul className="mt-4 space-y-3">
                  <li>
                    <strong className="text-foreground">Droit d'accès</strong> : obtenir la confirmation que vos données sont traitées et en obtenir une copie.
                  </li>
                  <li>
                    <strong className="text-foreground">Droit de rectification</strong> : corriger des données inexactes ou incomplètes.
                  </li>
                  <li>
                    <strong className="text-foreground">Droit à l'effacement</strong> (« droit à l'oubli ») : demander la suppression de vos données, sous réserve des obligations légales de conservation.
                  </li>
                  <li>
                    <strong className="text-foreground">Droit à la limitation du traitement</strong> : restreindre l'utilisation de vos données dans certaines circonstances.
                  </li>
                  <li>
                    <strong className="text-foreground">Droit à la portabilité</strong> : recevoir vos données dans un format structuré et lisible par machine.
                  </li>
                  <li>
                    <strong className="text-foreground">Droit d'opposition</strong> : vous opposer au traitement fondé sur notre intérêt légitime.
                  </li>
                  <li>
                    <strong className="text-foreground">Droit de définir des directives post-mortem</strong> : définir le sort de vos données après votre décès.
                  </li>
                </ul>
                <p className="mt-6">
                  Pour exercer ces droits, contactez-nous à :{" "}
                  <a href="mailto:contact@edgely.trade" className="text-primary hover:underline">
                    contact@edgely.trade
                  </a>
                </p>
                <p className="mt-2">
                  Nous nous engageons à répondre dans un délai d'un mois (art. 12 RGPD). En cas de demande complexe ou
                  de volume important, ce délai peut être prolongé de deux mois supplémentaires, avec notification préalable.
                </p>
                <p className="mt-4">
                  Vous avez également le droit d'introduire une réclamation auprès de l'autorité de contrôle compétente :{" "}
                  <strong className="text-foreground">Commission Nationale de l'Informatique et des Libertés (CNIL)</strong>,
                  3 Place de Fontenoy – TSA 80715 – 75334 Paris Cedex 07 — <a href="https://www.cnil.fr" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">www.cnil.fr</a>
                </p>
              </section>

              {/* 8. Sécurité */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">8. Sécurité des données</h2>
                <p>
                  Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données
                  contre tout accès non autorisé, perte, destruction ou altération, notamment :
                </p>
                <ul className="mt-4 list-disc pl-6 space-y-1">
                  <li>Chiffrement des communications via HTTPS/TLS</li>
                  <li>Stockage des mots de passe par hachage cryptographique (bcrypt)</li>
                  <li>Accès aux données restreint au seul utilisateur propriétaire</li>
                  <li>Stockage des fichiers dans des buckets S3 privés avec accès signé temporaire</li>
                  <li>Accès administrateur limité et journalisé</li>
                </ul>
                <p className="mt-4">
                  En cas de violation de données susceptible d'engendrer un risque pour vos droits et libertés, nous nous
                  engageons à notifier la CNIL dans les 72 heures et à vous en informer sans délai injustifié lorsque ce
                  risque est élevé (art. 33 et 34 RGPD).
                </p>
              </section>

              {/* 9. Cookies */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">9. Cookies et traceurs</h2>
                <p>
                  Edgely utilise des cookies strictement nécessaires au fonctionnement du service (maintien de la session
                  d'authentification). Ces cookies ne nécessitent pas votre consentement.
                </p>
                <p className="mt-3">
                  L'outil de mesure d'audience Plausible Analytics que nous utilisons n'utilise aucun cookie et ne nécessite
                  pas de consentement.
                </p>
                <p className="mt-3">
                  Si nous devions intégrer d'autres cookies (par exemple Google Analytics), nous vous en informerions et
                  recueillerions votre consentement préalable via un bandeau de cookies.
                </p>
              </section>

              {/* 10. Mineurs */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">10. Protection des mineurs</h2>
                <p>
                  Le service Edgely est strictement réservé aux personnes âgées de 18 ans ou plus. Nous ne collectons pas
                  sciemment de données personnelles concernant des mineurs. Si vous constatez qu'un mineur a créé un compte,
                  contactez-nous à{" "}
                  <a href="mailto:contact@edgely.trade" className="text-primary hover:underline">
                    contact@edgely.trade
                  </a>{" "}
                  afin que nous puissions supprimer les données dans les meilleurs délais.
                </p>
              </section>

              {/* 11. Modifications */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">11. Modifications de la politique de confidentialité</h2>
                <p>
                  Nous nous réservons le droit de modifier la présente politique à tout moment. En cas de modification
                  substantielle, vous serez informé par email au moins 30 jours avant l'entrée en vigueur des nouvelles
                  dispositions. La version en vigueur est toujours accessible à l'adresse{" "}
                  <span className="text-foreground font-medium">edgely.io/privacy</span>.
                </p>
                <p className="mt-3">
                  La poursuite de l'utilisation du service après notification vaut acceptation des nouvelles conditions.
                </p>
              </section>

              {/* 12. Contact */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4">12. Contact</h2>
                <p>
                  Pour toute question relative à la présente politique ou à vos données personnelles :
                </p>
                <div className="mt-3 p-4 bg-muted rounded-lg">
                  <p><strong className="text-foreground">Edgely</strong></p>
                  <p>173 rue de Courcelles, 75017 Paris, France</p>
                  <p>
                    <a href="mailto:contact@edgely.trade" className="text-primary hover:underline">
                      contact@edgely.trade
                    </a>
                  </p>
                </div>
              </section>

            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
